// extracted by mini-css-extract-plugin
module.exports = {"app":"app___3sz-J","brand":"brand____u4av","appContent":"appContent___gsYlq"};